import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es"; // idioma español

registerLocale("es", es);


// Genera arreglo de horas con formato "HH:00"
const generarHoras = (inicio, fin) => {
  const horas = [];
  for (let h = inicio; h < fin; h++) {
    horas.push(`${h}:00`);
  }
  return horas;
};

// Horarios por día
const horasPorDia = {
  lunes: generarHoras(9, 21),
  martes: generarHoras(9, 21),
  miércoles: generarHoras(9, 21),
  jueves: generarHoras(9, 21),
  viernes: generarHoras(9, 21),
  sábado: generarHoras(8, 22),
  domingo: generarHoras(8, 19),
};


 
// Días de la semana
const obtenerDiaDeSemana = (fechaStr) => {
  const dias = [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ];
  const fecha = new Date(fechaStr + "T00:00");
  return dias[fecha.getDay()];
};

function App() {
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [horasOcupadas, setHorasOcupadas] = useState([]);

  useEffect(() => {
    if (fechaSeleccionada) {
      const formato = fechaSeleccionada.toISOString().split("T")[0];
      axios
        .get("https://sues-store-production.up.railway.app/citas", {
          params: { fecha: formato },
        })
        .then((res) => {
          setHorasOcupadas(res.data);
        })
        .catch((err) => {
          console.error("Error cargando citas:", err);
          alert("❌ Error al cargar las citas. Intenta nuevamente.");
        });
    }
  }, [fechaSeleccionada]);

  const manejarReserva = async (hora) => {
    const cliente = prompt("Ingresa tu nombre:")?.trim();
    if (!cliente) return alert("❌ El nombre es obligatorio.");

    const telefono = prompt("Ingresa tu teléfono:")?.trim();
    if (!telefono) return alert("❌ El teléfono es obligatorio.");

    const correo = prompt("Ingresa tu correo:")?.trim();
    if (!correo) return alert("❌ El correo es obligatorio.");

    try {
      const formato = fechaSeleccionada.toISOString().split("T")[0];
      await axios.post("https://sues-store-production.up.railway.app/citas", {
        cliente,
        telefono,
        correo,
        fecha: formato,
        hora,
      });
      alert("✅ Cita agendada con éxito");
      setHorasOcupadas((prev) => [...prev, hora]);
    } catch (err) {
      console.error("Error al guardar cita:", err);
      alert("❌ No se pudo guardar la cita o alguien acaba de reservarla. Intenta nuevamente.");
    }
  };

  const esFechaPasada = (fecha) => {
    const hoy = new Date();
    return fecha < new Date(hoy.toDateString());
  };

  const formatoFecha = fechaSeleccionada
    ? fechaSeleccionada.toISOString().split("T")[0]
    : "";

  return (
    <div className="App">
      <h1>SUES Barbershop 💈</h1>

      {/* ✅ DatePicker aquí */}
      <DatePicker
  selected={fechaSeleccionada}
  onChange={(date) => setFechaSeleccionada(date)}
  dateFormat="dd/MM/yyyy" // más familiar en español
  minDate={new Date()}
  placeholderText="Selecciona una fecha"
  className="datepicker"
  locale="es" // ✅ idioma español
/>


      {fechaSeleccionada && (
        <>
          {esFechaPasada(fechaSeleccionada) ? (
            <p style={{ color: "red" }}>
              ❌ No puedes agendar en fechas pasadas.
            </p>
          ) : (
            <>
              <h2>Horarios disponibles para {formatoFecha}:</h2>
              <ul>
                {(horasPorDia[obtenerDiaDeSemana(formatoFecha)] || [])
                  .filter((hora) => !horasOcupadas.includes(hora))
                  .map((hora) => (
                    <li key={hora}>
                      {hora}{" "}
                      <button onClick={() => manejarReserva(hora)}>
                        Reservar
                      </button>
                    </li>
                  ))}
              </ul>
            </>
          )}
        </>
      )}

      <div className="contacto">
  <h2>📍 Contáctanos</h2>
  <p><strong>Teléfono:</strong> <a href="https://wa.me/573152781700" target="_blank" rel="noreferrer">315 278 1700</a></p>
  <p><strong>Instagram:</strong> <a href="https://www.instagram.com/suesbarbershop/?next=%2Fsues.store.co%2F" target="_blank" rel="noreferrer">@suesbarbershop</a></p>
  <p><strong>Dirección:</strong> Calle 9 #7-16, Cartago</p>
</div>
    </div>
    
  );
  
}

export default App;


